export default function Watermark (name, opts = {}) {
    return new Promise(function (resolve, reject) {
      const options = {
        color: '#3E3E50',
        channel: 'development',
        time: new Date(),
        output: '',
        width: 200,
        height: 200,
        ...opts
      }
  
      const svg = `<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        class="watermark-svg"
        viewBox="0 0 35 35"
        width="200"
        height="200"
        >
        <g class="path" transform="rotate(-45, 17.5, 17.5)" fill="${options.color}" font-family="Segoe UI,Arial">
          <text text-anchor="start" x="25%" y="50%" font-size="4">${name}</text>
          <text text-anchor="start" x="25%" y="50%" dy="-3.5" dx="0" font-size="2">${options.channel}</text>
          <text text-anchor="start" x="25%" y="50%" dy="3" dx="0" font-size="2">${options.time}</text>
        </g>
      </svg>`
  
      if (options.output === 'svg') {
        resolve(svg)
        return false
      }
  
      const svgDataUrl = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)))
  
      const img = new Image()
      img.width = options.width
      img.height = options.height
  
      img.onload = function () {
        if (options.output === 'img') {
          resolve(img)
          return false
        }
  
        const canvas = document.createElement('canvas')
        canvas.width = options.width
        canvas.height = options.height
        let ctx = null
  
        try {
          ctx = canvas.getContext('2d')
        } catch (err) {
          reject(err.message)
          return false
        }
  
        ctx.drawImage(img, 0, 0)
        resolve(canvas.toDataURL('image/png'))
      }
  
      img.src = svgDataUrl
    })
  }